"use client";

import { Play } from "lucide-react";
import { useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CaptureTheEssenceOfMoments() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);
  const videos = [{
    id: 1,
    thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/brand_event_moments.png",
    video: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/brand_event_moments.png",
    title: "Brand Events"
  }, {
    id: 2,
    thumbnail: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/creative_production_showcase.png",
    video: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/creative_production_showcase.png",
    title: "Creative Productions"
  }];
  const handleMouseEnter = (index: number) => {
    setHoveredIndex(index);
    const video = videoRefs.current[index];
    if (video) {
      video.currentTime = 0;
      video.play();
      setTimeout(() => {
        if (video) {
          video.pause();
        }
      }, 2000);
    }
  };
  const handleMouseLeave = (index: number) => {
    setHoveredIndex(null);
    const video = videoRefs.current[index];
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  };
  return <section ref={ref} className="relative bg-dark-background py-20 px-4 overflow-hidden">
      <div className={`max-w-7xl mx-auto transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground-dark mb-4">
            Capture the Essence of Moments
          </h2>
          <p className="text-lg text-foreground-dark/80 max-w-2xl mx-auto">
            Experience our work through immersive video storytelling—hover to preview our creative excellence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {videos.map((item, i) => <div key={item.id} data-index={i} className={`relative group cursor-pointer rounded-lg overflow-hidden shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${hoveredIndex === i ? "scale-105 shadow-[0_12px_40px_rgb(0_0_0_/_0.24)]" : "hover:scale-[1.02]"} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${i * 100}ms`,
          animation: hoveredIndex === i ? "pulse 1.5s ease-in-out infinite" : "none"
        }} onMouseEnter={() => handleMouseEnter(i)} onMouseLeave={() => handleMouseLeave(i)}>
              <div className="relative aspect-video bg-muted-dark-background">
                <img src={item.thumbnail} alt={item.title} className={`w-full h-full object-cover transition-opacity duration-[var(--duration-medium)] ${hoveredIndex === i ? "opacity-0" : "opacity-100"}`} />
                <video ref={el => {
              videoRefs.current[i] = el;
            }} src={item.video} muted playsInline className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[var(--duration-medium)] ${hoveredIndex === i ? "opacity-100" : "opacity-0"}`} />
                <div className={`absolute inset-0 surface-overlay flex items-center justify-center transition-opacity duration-[var(--duration-medium)] ${hoveredIndex === i ? "opacity-0" : "opacity-100"}`}>
                  <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center shadow-medium group-hover:bg-accent-hover transition-all duration-[var(--duration-medium)] group-hover:scale-110">
                    <Play className="w-8 h-8 text-foreground-accent fill-foreground-accent ml-1" />
                  </div>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-dark-background/90 to-transparent p-6">
                <h3 className="text-xl font-display font-semibold text-foreground-dark">
                  {item.title}
                </h3>
              </div>
            </div>)}
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1.02);
          }
          50% {
            transform: scale(1.05);
          }
        }
      `}</style>
    </section>;
}